import { render, staticRenderFns } from "./rentPlaceDetail.vue?vue&type=template&id=1bac8734&scoped=true"
import script from "./rentPlaceDetail.vue?vue&type=script&lang=js"
export * from "./rentPlaceDetail.vue?vue&type=script&lang=js"
import style0 from "./rentPlaceDetail.vue?vue&type=style&index=0&id=1bac8734&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bac8734",
  null
  
)

export default component.exports